module.exports = __webpack_public_path__ + "static/img/logos_220px_myapp.c8d587b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/open/panels/cooperation/img/network/logos_220px_myapp.png
// module id = +v1x
// module chunks = 0